'use client';
import { jsx } from '@emotion/react/jsx-runtime';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const optionallyWrapped = (child, wrap, attributes)=>wrap ? /*#__PURE__*/ jsx("span", _extends({}, attributes, {
        children: child
    })) : child;

export { optionallyWrapped };
//# sourceMappingURL=optionallyWrapped.js.map
